/** @format */

//! our url: https://play-smart.carmel6000.com/
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import React from "react";
import { AuthProvider } from "@hilma/auth";
// import { AuthProvider, PrivateRoute, HomeRoute, MultipleRoute } from '@hilma/auth';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { provide } from "@hilma/tools";
//components:
// import Statistics from "./pages/statistics/Statisctics";
// import GameListTable from "./pages/gameListTable/GameListTable";
// import BoardList from "./pages/boardList/BoardList";
import MailSentComp from "./pages/mailSentComp/MailSentComp";
import ResetSucceeded from "./pages/mailSentComp/ResetSucceeded";

//style:
import "./App.css";
//stores:
import { DataProvider } from "./stores/Data.store";

function App() {
  return (
    <div className="App">
      <Router>
        <AuthProvider>
          <Switch>
            {/* <Route path="/BoardList" component={BoardList} /> */}
            {/* <Route path="/GameListTable" component={GameListTable} /> */}
            <Route path="/MailSentComp" component={MailSentComp} />
            <Route path="/ResetSucceeded" component={ResetSucceeded} />
            <a>"TODO: ADD STATISTICS!!!!!!"</a>
            {/* TODO!!!!!!! */}
            {/* <Route path="/" component={Statistics} /> */}
          </Switch>
        </AuthProvider>
      </Router>
    </div>
  );
}

export default provide(DataProvider)(App);

// TODO aya: טווח תאריכים- כשעוברים לרשימת משחקים וחוזרים חזרה זה חוזר להיות הכל ולא מה שהיה קודם
// TODO aya: לקבל רשימת משחקים בטווח תאריכים שנבחר גם בטבלה וגם בעמוד של רשימת משחקים
// TODO: צריך איכשהו לראות תאריכי התחלה וסיום אחד ליד השני?

// export default App;



// WEBPACK FOOTER //
// ./src/App.js